<button class="btn btn-default" type="button" (click)="backPage()" attr.aria-label="{{ 'ACTIONS.BACK_TO_LIST' | translate }}">{{ 'ACTIONS.BACK_TO_LIST' | translate }}</button>
